import { send } from '@fiverr-private/futile/lib/send';
import _ from 'lodash';
import {
    MP_CLICKED_COMPARE_PACKAGES,
    MP_CLICKED_CONTACT_ME,
    MP_ClICKED_NAVBAR,
    MP_CLICKED_PACKAGE_SELECT,
    MP_CLICKED_SELLER_NAME_ANCHOR,
    MP_SHOW_PAGE_NAME,
    MP_VIDEO_THUMBNAIL_SIZE,
    MP_CLICKED_GALLERY_FULL_SCREEN,
    MP_CLICKED_BREADCRUMBS_PRO,
    MP_CLICKED_BREADCRUMBS_CATEGORY,
    MP_CLICKED_BREADCRUMBS_SUBCATEGORY,
    MP_CLICKED_BREADCRUMBS_NESTED_SUBCATEGORY, MP_CLICKED_TAB
} from '../mixPanelEvents';
import {
    createMpComparePackagesParams,
    createMpPackageSelectParams,
    createMpSellerAnchorClickParams,
    createMpShowPageEventParams,
    createMpTopNavClickParams,
    createMpBreadcrumbsClickParams,
    createMpClickedTab
} from '../mixPanelEventsData';
import {
    BQ_CLICKED_CUSTOM_ORDER,
    BQ_CLICKED_PACKAGE_SELECT,
    BQ_CLICKED_REPORT_GIG,
    BQ_GIG_DESCRIPTION_SEE_MORE,
    BQ_CLICKED_CONTACT_SELLER,
    BQ_CLICKED_PACKAGES_TAB,
    BQ_CLICKED_REVIEWS_SNIPPET_MORE
} from '../bigQueryEvents';
import {
    createBqCustomOrderClickParams,
    createBqDescriptionSeeMoreParams,
    createBqPackageSelectParams,
    createBqReportGigClickParams,
    createBqContactSellerClickParams,
    createBqClickedPackagesTab,
    createBqReviewsSnippetMoreClickParams,
    createGigGalleryReportParams,
    PAGE_NAME
} from '../bigQueryEventsData';
import { SINGLE_PACKAGE, TRIPLE_PACKAGE, GIG_GALLERY } from '../events';

class BiEvents {

    constructor({ requestContext, general, packagesCount }) {
        const { current_user, page_ctx_id } = requestContext;
        this.reportingData = {
            ...general,
            userId: current_user ? current_user.id : null,
            pageCtxId: page_ctx_id,
            packagesCount
        };
    }

    sendBigQueryEvent({ eventName, params = {} }) {
        if (!this.reportingData) {
            return;
        }

        const { packagesCount, pageCtxId, userId } = this.reportingData;

        const generalEventData = {
            gig: { packages_type: packagesCount === 3 ? TRIPLE_PACKAGE : SINGLE_PACKAGE },
            user: { id: userId },
            page: { ctx_id: pageCtxId, name: PAGE_NAME }
        };

        const eventParams = { ...this.reportingData, ...params };
        const eventData = this.createBigQueryEventData(eventName, eventParams);

        send.sendEvents(_.merge(generalEventData, eventData));
    }

    createBigQueryEventData(eventName, eventParams) {
        switch (eventName) {
            case BQ_CLICKED_PACKAGE_SELECT:
                return createBqPackageSelectParams(eventParams);
            case BQ_CLICKED_CUSTOM_ORDER:
                return createBqCustomOrderClickParams(eventParams);
            case BQ_CLICKED_REPORT_GIG:
                return createBqReportGigClickParams(eventParams);
            case BQ_GIG_DESCRIPTION_SEE_MORE:
                return createBqDescriptionSeeMoreParams(eventParams);
            case BQ_CLICKED_CONTACT_SELLER:
                return createBqContactSellerClickParams(eventParams);
            case BQ_CLICKED_PACKAGES_TAB:
                return createBqClickedPackagesTab(eventParams);
            case BQ_CLICKED_REVIEWS_SNIPPET_MORE:
                return createBqReviewsSnippetMoreClickParams(eventParams);
            case GIG_GALLERY:
                return createGigGalleryReportParams(eventParams);
            default:
                return {};
        }
    }

    sendMixPanelEvent({ mpEventType, eventName, params = {} }) {
        if (!this.reportingData || typeof MixpanelWrapper === 'undefined') {
            return;
        }

        const eventParams = { ...this.reportingData, ...params };
        const eventData = this.createMixPanelEventData(eventName, eventParams);

        if (mpEventType === 'trackPageView') {
            MixpanelWrapper.trackPageView(eventName, eventData);
        } else {
            MixpanelWrapper.trackEvent(eventName, eventData);
        }
    }

    createMixPanelEventData(eventName, eventParams = {}) {
        switch (eventName) {
            case MP_SHOW_PAGE_NAME:
                return createMpShowPageEventParams(eventParams);
            case MP_ClICKED_NAVBAR:
                return createMpTopNavClickParams(eventParams);
            case MP_CLICKED_PACKAGE_SELECT:
                return createMpPackageSelectParams(eventParams);
            case MP_CLICKED_COMPARE_PACKAGES:
                return createMpComparePackagesParams(eventParams);
            case MP_CLICKED_SELLER_NAME_ANCHOR:
                return createMpSellerAnchorClickParams(eventParams);
            case MP_CLICKED_TAB:
                return createMpClickedTab(eventParams);
            case MP_CLICKED_BREADCRUMBS_PRO:
            case MP_CLICKED_BREADCRUMBS_CATEGORY:
            case MP_CLICKED_BREADCRUMBS_SUBCATEGORY:
            case MP_CLICKED_BREADCRUMBS_NESTED_SUBCATEGORY:
                return createMpBreadcrumbsClickParams(eventParams);
            case MP_CLICKED_CONTACT_ME:
            case MP_VIDEO_THUMBNAIL_SIZE:
            case MP_CLICKED_GALLERY_FULL_SCREEN:
            default:
                return eventParams;
        }
    }

    getEnrichmentData() {
        return {
            'Category Id': this.reportingData.categoryId,
            'Sub Category Id': this.reportingData.subCategoryId,
            'Nested Sub Category Id': this.reportingData.nestedSubCategoryId,
            'Is pro': this.reportingData.isPro,
            userId: this.reportingData.userId,
            pageCtxId: this.reportingData.pageCtxId
        };
    }
}

export default BiEvents;
